import React, { forwardRef, useId } from 'react'
import { cn } from '@utils'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helperText?: string
}

// forwardRef is required: forms bind these with `{...register('field')}`, and
// react-hook-form passes a ref it must be able to attach.
const Input = forwardRef<HTMLInputElement, InputProps>(({ label, error, helperText, className, id, ...props }, ref) => {
  const generatedId = useId()
  const inputId = id || generatedId

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={cn(
          'block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs placeholder-gray-400 focus:outline-hidden focus:ring-primary-500 focus:border-primary-500',
          error && 'border-red-300 focus:border-red-500 focus:ring-red-500',
          className
        )}
        {...props}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
      {helperText && !error && <p className="text-sm text-gray-500">{helperText}</p>}
    </div>
  )
})

Input.displayName = 'Input'

export default Input
